"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _H = _interopRequireDefault(require("../elements/headings/H5"));

var _AlertTypes = require("../alert/AlertTypes");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var UIAlert =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIAlert, _PureComponent);

  function UIAlert() {
    (0, _classCallCheck2.default)(this, UIAlert);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIAlert).apply(this, arguments));
  }

  (0, _createClass2.default)(UIAlert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          closeable = _this$props.closeable,
          onClose = _this$props.onClose,
          titleText = _this$props.titleText,
          type = _this$props.type,
          use = _this$props.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "closeable", "onClose", "titleText", "type", "use"]);
      var computedClassName = (0, _classnames.default)('alert', 'private-alert', 'private-alert--page-wide', _AlertTypes.ALERT_TYPES[type], className, {
        'private-alert--dismissable alert-dismissable': closeable
      }, {
        'private-alert--inline': use === 'inline'
      });
      return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
        "aria-atomic": "true",
        "aria-live": "assertive",
        className: computedClassName,
        role: "alert"
      }), _react.default.createElement("div", {
        className: "private-alert__inner"
      }, titleText ? _react.default.createElement(_H.default, {
        className: "private-alert__title"
      }, titleText) : null, _react.default.createElement("div", {
        className: "private-alert__body has--vertical-spacing"
      }, children)), closeable ? _react.default.createElement(_UICloseButton.default, {
        "aria-hidden": true,
        className: "close private-alert__close",
        onClick: onClose,
        size: "medium"
      }) : null);
    }
  }]);
  return UIAlert;
}(_react.PureComponent);

UIAlert.displayName = 'UIAlert';
UIAlert.propTypes = {
  children: _propTypes.default.node,
  closeable: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func,
  titleText: _propTypes.default.node,
  type: _propTypes.default.oneOf(Object.keys(_AlertTypes.ALERT_TYPES)).isRequired,
  use: _propTypes.default.oneOf(Object.keys(_AlertTypes.ALERT_USES)).isRequired
};
UIAlert.defaultProps = {
  closeable: false,
  type: 'info',
  use: 'default'
};
var _default = UIAlert;
exports.default = _default;
module.exports = exports.default;